(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('EnsambleIbqDetailController', EnsambleIbqDetailController);

    EnsambleIbqDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Ensamble', 'MusicalPiece', 'MusicSheet'];

    function EnsambleIbqDetailController($scope, $rootScope, $stateParams, previousState, entity, Ensamble, MusicalPiece, MusicSheet) {
        var vm = this;

        vm.ensamble = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('virtuallibraryApp:ensambleUpdate', function(event, result) {
            vm.ensamble = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
